module.exports = __webpack_public_path__ + "assets/default_media_1200x630.jpg";